import { Sparkles } from "lucide-react";

const AnswerSummary = ({ text }) => {
  if (!text) return null;
  return (
    <aside
      data-testid="answer-summary"
      className="not-prose my-8 rounded-2xl border border-[hsl(var(--accent))]/40 bg-[hsl(var(--accent))]/[0.06] p-6 sm:p-7"
    >
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-[hsl(var(--accent))]">
        <Sparkles size={13} strokeWidth={1.8} /> Answer in 30 seconds
      </div>
      <p className="mt-3 text-[15px] sm:text-base leading-relaxed text-[hsl(var(--foreground))]/90">
        {text}
      </p>
    </aside>
  );
};

export default AnswerSummary;
